import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import styles from './Tooltip.module.scss.js';

var TooltipBody = function (props) {
    var _a;
    var classNameBody = classNames(styles.body, props.bgColor && styles[props.bgColor], (_a = {},
        _a[styles.withMouseClick] = props.withMouseClick,
        _a), props.className);
    return jsx("div", { className: classNameBody, children: props.children });
};

export { TooltipBody as default };
//# sourceMappingURL=TooltipBody.js.map
